import { ProgressBarItem } from 'components/ProgressBar';

import { PAID_NO_FINANCE_BASE_STEPS, REVIEW_STEP } from './constants';

import { LenderStatus } from '../../Content/Lenders/constants';
import {
  getInAwaitDecision,
  getInCompleteJob,
  getInCompletePurchase,
  getInFinished,
  getInNotApproved,
  getInSatNote,
} from '../helpers';

export const getNonFinanceSteps = (
  lenderStatus: LenderStatus,
  isDeliveryOnly = false,
): ProgressBarItem[] => {
  const satNote = getInSatNote(lenderStatus);
  const finished = getInFinished(lenderStatus);
  return [
    ...PAID_NO_FINANCE_BASE_STEPS,
    {
      type: 'multi',
      title: 'Complete',
      substeps: [
        {
          title: isDeliveryOnly ? 'Await delivery' : 'Await job completion',
          active: !satNote && !finished,
          type: 'single',
        },
        {
          title: 'Sign Satisfaction Note',
          active: satNote,
          type: 'single',
        },
        {
          title: 'Finished',
          active: finished,
          type: 'single',
        },
      ],
    },
  ];
};

export const getChooseSteps = (lenderStatus: LenderStatus): ProgressBarItem => {
  const inChoosePaymentStep =
    getInAwaitDecision(lenderStatus) || getInCompletePurchase(lenderStatus);
  if (!inChoosePaymentStep)
    return {
      type: 'single',
      title: 'Choose Payment',
      active: false,
    };
  return {
    type: 'multi',
    title: 'Choose Payment',
    substeps: [
      {
        title: 'Choose Rate',
        active: false,
        type: 'single',
      },
      {
        title: 'Apply For Finance',
        active: false,
        type: 'single',
      },
      {
        title: 'Await Decision',
        active: getInAwaitDecision(lenderStatus),
        type: 'single',
      },
      {
        title: 'Complete Purchase',
        active: getInCompletePurchase(lenderStatus),
        type: 'single',
      },
    ],
  };
};

export const getCompleteSteps = (
  lenderStatus: LenderStatus,
): ProgressBarItem => {
  const inChoosePaymentStep =
    getInAwaitDecision(lenderStatus) || getInCompletePurchase(lenderStatus);
  if (inChoosePaymentStep)
    return {
      type: 'single',
      title: 'Complete',
      active: false,
    };
  const notApproved = getInNotApproved(lenderStatus);
  if (notApproved)
    return {
      type: 'single',
      title: 'Not Approved',
      active: false,
    };
  return {
    type: 'multi',
    title: 'Complete',
    substeps: [
      {
        title: 'Await job completion',
        active: getInCompleteJob(lenderStatus),
        type: 'single',
      },
      {
        title: 'Sign Satisfaction Note',
        active: getInSatNote(lenderStatus),
        type: 'single',
      },
      {
        title: 'Finished',
        active: getInFinished(lenderStatus),
        type: 'single',
      },
    ],
  };
};

export const getFinanceSteps = (
  lenderStatus: LenderStatus,
): ProgressBarItem[] => {
  const chooseSteps = getChooseSteps(lenderStatus);
  const completeSteps = getCompleteSteps(lenderStatus);
  return [REVIEW_STEP, chooseSteps, completeSteps];
};
